// import { useNotification } from "context/NotificationContext";
// import OverAllNotifcationCardUI from "./OverAllNotifcationCardUI";

// const NotificationContainer = () => {
//   const { notification } = useNotification();

//   if (!notification) return null;

//   return (
//     <div className="fixed top-10 right-0 w-2/3 px-4" style={{
//     zIndex:1000
// }}>
//       <OverAllNotifcationCardUI data={notification} />
//     </div>
//   );
// };

// export default NotificationContainer;

import React from "react";
import { useNotification } from "context/NotificationContext";
import OverAllNotifcationCardUI from "./OverAllNotifcationCardUI";
import "./Notification.css";

const NotificationContainer = () => {
  const { notification } = useNotification();

  if (!notification) {
    return null;
  }

  return (
    <div
      className="fixed top-20 right-0  w-2/3 animate-slide-in"
      style={{
        pointerEvents: "auto",
        zIndex:1000
      }}
    >
      <OverAllNotifcationCardUI
        data={notification}
      />
    </div>
  );
};

export default NotificationContainer;